
// import {fire, fireAuth} from '@/firebase/config'
import { useStore } from "vuex";
import { onMounted, ref, provide } from "vue";
import { a, n } from "@/composables/types";
import useCss from "@/composables/useCss";
// import { useRouter, useRoute } from "vue-router";

export default {
  // components: [],
  setup() {
    const ss = useStore().state;
    // const router = useRouter();
    // const sg = useStore().getters;
    ///////////////////////

    ///////////css////////////
    const { cqueA, cque, cLenEqual, cexNone } = useCss();
    //......................................

    onMounted(() => {
      cexNone("exBtn", "exOn", "exStyleSpan", "exText");
      // cexNone("exHeading", "exOn", "exStylePara");
    });
    ////////////////////////
    return {
      ss
    };
  }
};
